// extracted by mini-css-extract-plugin
var _1 = "LoadGuard__chapterLoadingBackground--jrsxw LoadGuard__defaultLoadCenter--owYIz";
var _2 = "LoadGuard__defaultLoadBox--XTEdm";
var _3 = "LoadGuard__defaultLoadCenter--owYIz";
export { _1 as "chapterLoadingBackground", _2 as "defaultLoadBox", _3 as "defaultLoadCenter" }
